import { CheckCircleIcon, CircleXIcon } from 'lucide-react'
import { BeatLoader } from 'react-spinners'

import { Tooltip, TooltipContent, TooltipTrigger } from '../tooltip'

export type ExistsState = 'pending' | 'in_progress' | 'available' | 'exists'

interface Props {
    exists: ExistsState
    className?: string
    name: string
}

const icons = {
    pending: '',
    in_progress: <BeatLoader size={5} color="hsl(var(--primary))" />,
    available: <CheckCircleIcon className="text-success" />,
    exists: <CircleXIcon className="text-destructive" />,
}

const tooltipText = {
    available: 'available',
    exists: 'is already taken',
}

export default function ExistenceCheckIcon({ className, exists, name }: Props) {
    return (
        <Tooltip delayDuration={250}>
            <TooltipTrigger>
                <span className={className}>{icons[exists]}</span>
            </TooltipTrigger>
            <TooltipContent>
                {name} {tooltipText[exists]}
            </TooltipContent>
        </Tooltip>
    )
}
